import { gql } from "graphql-request";

// ─── Queries ────────────────────────────────────────────────────────

export const GET_SUPPLIER_PORTAL = gql`
  query SupplierPortal($token: String!, $sessionToken: String) {
    supplierPortal(token: $token, sessionToken: $sessionToken) {
      _id
      caseNumber
      poNumber
      middlemanName
      factoryName
      productDescription
      portalEnabled
      portal2faEnabled
    }
  }
`;

export const GET_SUPPLIER_PORTAL_QUESTIONS = gql`
  query SupplierPortalQuestions($token: String!, $sessionToken: String) {
    supplierPortalQuestions(token: $token, sessionToken: $sessionToken) {
      _id
      questionId
      question
      category
      options
      answer
      status
    }
  }
`;

export const GET_SUPPLIER_PORTAL_DOC_SLOTS = gql`
  query SupplierPortalDocSlots($token: String!, $sessionToken: String) {
    supplierPortalDocSlots(token: $token, sessionToken: $sessionToken) {
      slotId
      label
      description
      tab
      requirements
      status
      importerNote
      reviewFeedback
      documents {
        _id
        filename
        mimeType
        sizeBytes
        status
        createdAt
      }
    }
  }
`;

export const GET_SUPPLIER_PORTAL_DOCUMENT_REQUESTS = gql`
  query SupplierPortalDocumentRequests($token: String!, $sessionToken: String) {
    supplierPortalDocumentRequests(token: $token, sessionToken: $sessionToken) {
      _id
      slotId
      label
      description
      reason
      requirements
      status
      requestedBy
      createdAt
    }
  }
`;

// ─── Mutations ──────────────────────────────────────────────────────

export const ANSWER_SUPPLIER_PORTAL_QUESTION = gql`
  mutation AnswerSupplierPortalQuestion($token: String!, $sessionToken: String, $questionId: String!, $answer: String!) {
    answerSupplierPortalQuestion(token: $token, sessionToken: $sessionToken, questionId: $questionId, answer: $answer) {
      _id
      questionId
      answer
      status
    }
  }
`;

export const UPLOAD_SUPPLIER_PORTAL_DOCUMENT = gql`
  mutation UploadSupplierPortalDocument($token: String!, $sessionToken: String, $slotId: String!, $filename: String!, $mimeType: String!, $sizeBytes: Int!) {
    uploadSupplierPortalDocument(token: $token, sessionToken: $sessionToken, slotId: $slotId, filename: $filename, mimeType: $mimeType, sizeBytes: $sizeBytes) {
      docId
      uploadUrl
      s3Key
    }
  }
`;

export const CONFIRM_SUPPLIER_PORTAL_DOCUMENT_UPLOAD = gql`
  mutation ConfirmSupplierPortalDocumentUpload($token: String!, $sessionToken: String, $docId: ID!) {
    confirmSupplierPortalDocumentUpload(token: $token, sessionToken: $sessionToken, docId: $docId) {
      _id
      isEnglish
      detectedLanguage
    }
  }
`;

export const DELETE_SUPPLIER_PORTAL_DOCUMENT = gql`
  mutation DeleteSupplierPortalDocument($token: String!, $sessionToken: String, $docId: ID!) {
    deleteSupplierPortalDocument(token: $token, sessionToken: $sessionToken, docId: $docId)
  }
`;

export const GENERATE_FIRST_SALE_PORTAL_TOKEN = gql`
  mutation GenerateFirstSalePortalToken($caseId: ID!, $tenantId: ID) {
    generateFirstSalePortalToken(caseId: $caseId, tenantId: $tenantId) {
      token
    }
  }
`;

export const REVOKE_FIRST_SALE_PORTAL_TOKEN = gql`
  mutation RevokeFirstSalePortalToken($caseId: ID!, $tenantId: ID) {
    revokeFirstSalePortalToken(caseId: $caseId, tenantId: $tenantId)
  }
`;

export const UPDATE_PORTAL_DOC_SLOT_NOTE = gql`
  mutation UpdatePortalDocSlotNote($caseId: ID!, $slotId: String!, $tenantId: ID, $importerNote: String, $reviewFeedback: String) {
    updatePortalDocSlotNote(caseId: $caseId, slotId: $slotId, tenantId: $tenantId, importerNote: $importerNote, reviewFeedback: $reviewFeedback)
  }
`;

// ─── Portal 2FA ────────────────────────────────────────────────────

export const SEND_PORTAL_VERIFICATION_CODE = gql`
  mutation SendPortalVerificationCode($token: String!, $email: String!) {
    sendPortalVerificationCode(token: $token, email: $email) {
      success
    }
  }
`;

export const VERIFY_PORTAL_CODE = gql`
  mutation VerifyPortalCode($token: String!, $email: String!, $code: String!) {
    verifyPortalCode(token: $token, email: $email, code: $code) {
      verified
      sessionToken
    }
  }
`;

export const TOGGLE_PORTAL_2FA = gql`
  mutation TogglePortal2fa($caseId: ID!, $tenantId: ID, $enabled: Boolean!) {
    togglePortal2fa(caseId: $caseId, tenantId: $tenantId, enabled: $enabled)
  }
`;

export const ADD_PORTAL_AUTHORIZED_EMAIL = gql`
  mutation AddPortalAuthorizedEmail($caseId: ID!, $tenantId: ID, $email: String!) {
    addPortalAuthorizedEmail(caseId: $caseId, tenantId: $tenantId, email: $email)
  }
`;

export const REMOVE_PORTAL_AUTHORIZED_EMAIL = gql`
  mutation RemovePortalAuthorizedEmail($caseId: ID!, $tenantId: ID, $email: String!) {
    removePortalAuthorizedEmail(caseId: $caseId, tenantId: $tenantId, email: $email)
  }
`;
